<main>
    <apcam-error-page
        [title]="'shared.error.' + messageId | translate"
        [centered]="true">
        <div class="flex flex-wrap justify-center gap-4">
            <button matButton="filled" color="primary" (click)="redirect()">
                {{ 'shared.error.errorPage.goBack' | translate }}
            </button>
            @if (user != null) {
                <button matButton="filled" color="warn" (click)="logout()">
                    {{ 'shared.error.errorPage.logOut' | translate }}
                </button>
            }
        </div>
    </apcam-error-page>
</main>
